import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=999e41e2"
import script from "./AnimatedNumber.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports